// extracted by mini-css-extract-plugin
export default {"contentHeader":"Profile_contentHeader__yY4wq","profileAvatar":"Profile_profileAvatar__NQ8EX","rightHeader":"Profile_rightHeader__NduMt","profileName":"Profile_profileName__5WBEZ"};